import store from '../store';
import Cartabandoned from '../views/order/Cart.vue';
import { checkauth } from '../Helper';
import OrderPrint from '@/views/order/Print.vue';
import PrintReceipt from '@/views/order/PrintReceipt.vue';
import OrderMultiplePrint from '@/views/order/MultiplePrint.vue';

export default [
	{
		path: '/cartabandoned',
		name: 'cartabandoned',
		component: Cartabandoned,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
];
